import Swal from "sweetalert2";
import { v2ReactURL } from "../../utils/constant";
import { SwalFunction } from "./SwalFunction";
import { axiosFunction } from "./axiosFunction";
 


export const DeleteContactFunc = async (
  deletedContactIds: number[], // Assuming deletedContactIds is an array of numbers
  navigate: (path: string) => void, // Function to navigate to a different route
  contactType: string,
  refreshAnalytics?: boolean,
  setRefreshAnalytics?: React.Dispatch<React.SetStateAction<boolean>>,
  detailsPage: boolean = false, // Optional boolean parameter with a default value
  fetchData?: () => void
): Promise<void> => {
  const result = await SwalFunction(
    "Are You Sure?",
    "You Won't Be Able To Revert This!",
    "Yes, Delete It!",
    { icon: "warning" }
  );

  if (result.isConfirmed) {
    const response = await axiosFunction(
      `${v2ReactURL}/contact/${contactType}/deleteContact`,
      "DELETE",
      deletedContactIds
    );

    if (response.data == true) {
      if (detailsPage) {
        navigate("/reactcontact");
      }else{
        fetchData?.()
        setRefreshAnalytics?.(!refreshAnalytics);
      }  
    } else if (response.data === "accessdenied/accessdenied") {
      const res = await Swal.fire({
        title: `Access Denied`,
        icon: "info",
      });

      if (res.isConfirmed) {
        fetchData?.()
      }
    } else {
       await Swal.fire({
        title: `Contact (${response.data} ) won't be deleted because there are transactions available.`,
        icon: "info",
      });
      fetchData?.()
      setRefreshAnalytics?.(!refreshAnalytics);
      // if (res.isConfirmed) {
      //   window.location.reload();
      // }
    }
  }
};
